import { combineReducers } from 'redux';
import {
  createReducer,
  createRequestReducer,
  defaultGetReducer,
  defaultListInitialState,
  defaultObjectReducer,
  defaultObjectInitialState
} from 'utils';
import {
  GET_PROFILE_COMPANIES,
  GET_PROFILE_COMPANY,
  PUT_PROFILE_COMPANY_STATE,
  CLEAR_PROFILE_COMPANY,
  GET_PROFILE_COMPANY_BIKES,
  GET_PROFILE_COMPANY_EXTRAS,
  GET_PROFILE_COMPANY_LEAVE_LOCATIONS,
  GET_PROFILE_COMPANY_BOOKINGS,
  GET_PROFILE_COMPANY_RESERVATIONS,
  GET_PROFILE_COMPANY_SEASONS,
  GET_PROFILE_COMPANY_TARIFFS,
  GET_PROFILE_COMPANY_TARIFFS_SOURCE,
  GET_PROFILE_COMPANY_TIMELINE_BOOKINGS,
  POST_PROFILE_COMPANY_TIMELINE_BOOKING,
  PUT_PROFILE_COMPANY_TIMELINE_BOOKING,
  DELETE_PROFILE_COMPANY_TIMELINE_BOOKING
} from '../../constants/profile';

function createProfileReducer(reducerMap) {
  return (state, action) => {
    if (!state) {state = {};}

    const reducer = reducerMap[action.type];
    if (!reducer) {return state;}

    if (!action.meta || !action.meta.queryParams || !action.meta.queryParams.company) {
      return state;
    }

    const { company } = action.meta.queryParams;

    return Object.assign({}, state, {
      [company]: reducer(state[company], action)
    });
  };
}

const companiesInitial = defaultListInitialState();
const companies = createReducer(companiesInitial, {
  [GET_PROFILE_COMPANIES]: defaultGetReducer
});

const companyInitial = defaultObjectInitialState();
const company = createReducer(companyInitial, {
  [GET_PROFILE_COMPANY]: defaultObjectReducer,

  [PUT_PROFILE_COMPANY_STATE]: (state, action) => {
    if (!state.data || !action.status === 'SUCCESS') {
      return state;
    }

    if (action.meta.data.id !== state.data.id) {
      return state;
    }

    const isPublished = !action.meta.data.pendingState;

    return Object.assign({}, state, {
      data: Object.assign({}, state.data, {
        isPublished,
        pendingState: action.meta.data.pendingState
      })
    });
  },

  [CLEAR_PROFILE_COMPANY]: () => companyInitial
});

const bikes = createProfileReducer({
  [GET_PROFILE_COMPANY_BIKES]: defaultGetReducer
});

const extrasInitial = defaultListInitialState();
const extras = createReducer(extrasInitial, {
  [GET_PROFILE_COMPANY_EXTRAS]: defaultGetReducer
});

const bookingsInitial = defaultListInitialState();
const bookings = createReducer(bookingsInitial, {
  [GET_PROFILE_COMPANY_BOOKINGS]: defaultGetReducer
});

const reservationsInitial = defaultListInitialState();
const reservations = createReducer(reservationsInitial, {
  [GET_PROFILE_COMPANY_RESERVATIONS]: defaultGetReducer
});

const seasons = createProfileReducer({
  [GET_PROFILE_COMPANY_SEASONS]: defaultGetReducer
});

const tariffsInitial = defaultListInitialState();
const tariffs = createReducer(tariffsInitial, {
  [GET_PROFILE_COMPANY_TARIFFS]: defaultGetReducer
});

const tariffsSourceInitial = defaultListInitialState();
const tariffsSource = createReducer(tariffsSourceInitial, {
  [GET_PROFILE_COMPANY_TARIFFS_SOURCE]: defaultGetReducer
});

const leaveLocationsInitial = defaultListInitialState();
const leaveLocations = createReducer(leaveLocationsInitial, {
  [GET_PROFILE_COMPANY_LEAVE_LOCATIONS]: defaultGetReducer
});

const timelineBookingsInitial = defaultListInitialState();
const timelineBookings = createReducer(timelineBookingsInitial, {
  [GET_PROFILE_COMPANY_TIMELINE_BOOKINGS]: defaultGetReducer,

  [POST_PROFILE_COMPANY_TIMELINE_BOOKING]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => Object.assign({}, state, { isFetching: true, error: null }),

    SUCCESS: (state, action) => {
      const items = state.items.slice(0);
      items.push(action.response);

      return Object.assign({}, state, { items, isFetching: false });
    },

    FAIL: (state, action) => Object.assign({}, state, { isFetching: false, error: action.error })
  }),

  [PUT_PROFILE_COMPANY_TIMELINE_BOOKING]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => Object.assign({}, state, { isFetching: true, error: null }),

    SUCCESS: (state, action) => {
      const items = state.items.slice(0);
      const index = items.findIndex(item => item.uid === action.response.uid);

      if (index !== -1) {
        items.splice(index, 1, action.response);
      }

      return Object.assign({}, state, { items, isFetching: false });
    },

    FAIL: (state, action) => Object.assign({}, state, { isFetching: false, error: action.error })
  }),

  [DELETE_PROFILE_COMPANY_TIMELINE_BOOKING]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => Object.assign({}, state, { isFetching: true, error: null }),

    SUCCESS: (state, action) => {
      const items = state.items.filter(({ uid }) => uid !== action.meta.id);

      return Object.assign({}, state, { items, isFetching: false });
    },

    FAIL: (state, action) => Object.assign({}, state, { isFetching: false, error: action.error })
  })
});

export default combineReducers({
  companies,
  company,
  bikes,
  extras,
  bookings,
  reservations,
  seasons,
  tariffs,
  tariffsSource,
  leaveLocations,
  timelineBookings
});



// WEBPACK FOOTER //
// ./src/reducers/profile/companies.js